import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { AUTH_CONFIG } from '../../config/auth-config';
import { IAuthService } from '../../services/iauth.service';
import { ContainerManagerLoginComponent } from '../container-manager-login/container-manager-login.component';

@Component({
  selector: 'app-reset-senha',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputTextModule,
    ContainerManagerLoginComponent,
  ],
  templateUrl: './reset-senha.component.html',
  styleUrls: ['./reset-senha.component.scss'],
})
export class ResetSenhaComponent {
  private authService = inject(IAuthService);
  private fb = inject(FormBuilder);
  private mensagemService = inject(MessageService);
  private router = inject(Router);
  private config = inject(AUTH_CONFIG);

  form = this.criarForm();
  loadding = false;

  onSubmit() {
    this.loadding = true;
    this.form.disable();
    this.authService
      .solicitarRecuperarSenha(this.form.value.usuario!)
      .subscribe({
        next: () => {
          this.mensagemService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Solicitação realizada com sucesso!',
          });
          const loginRoute = this.config.routes?.loginRoute || 'login';
          this.router.navigate(['/', loginRoute]);
        },
      })
      .add(() => {
        this.loadding = false;
        this.form.enable();
      });
  }

  private criarForm() {
    return this.fb.group({
      usuario: new FormControl<string>('', {
        validators: [Validators.required, Validators.email],
        nonNullable: true,
      }),
    });
  }
}
